var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkyWalletIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M25 35c-2.75 0-5-2.25-5-5V15c0-2.75 2.25-5 5-5h15V5H5v35h35v-5H25z",
    fill: "#006DFF",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 10.7V5c0-2.75-2.25-5-5-5H5C2.225 0 0 2.25 0 5v35c0 2.75 2.225 5 5 5h35c2.75 0 5-2.25 5-5v-5.7c1.475-.875 2.5-2.45 2.5-4.3V15a4.97 4.97 0 00-2.5-4.3zM42.5 15v15H25V15h17.5zM5 40V5h35v5H25c-2.75 0-5 2.25-5 5v15c0 2.75 2.25 5 5 5h15v5H5z",
    fill: "#006DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 26.25a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z",
    fill: "#006DFF"
  })));
}
export default SvgSkyWalletIcon;